/// <reference path="../../../typings/tsd.d.ts" /> 

module warsApp.directives {
    export interface IManageAssignmentsScope extends ng.IScope {
        manageSection: Wars.Domain.Model.ManageSection;
        processConfigurationId:string;
        isConfigureMode: boolean;
        isEditMode: boolean;
        process: Wars.Domain.Model.Dtos.ProcessDto;
        cancel: any;
        saveAdd: any;
        clearUser: any;
        addAssignment: any;
        deleteAssignment: any;
        newAssignment: any;
        claimOptions: Wars.Domain.Model.ClaimDefinition[];
        isAdding: boolean;
        selectedUser: any;
        searchUsers: any;
        processClaims: Wars.Domain.Model.ClaimDefinition[];
        processClaimDefinitions: Wars.Domain.Model.ClaimDefinition[];
        userRepositories: string[];
        save: () => void;
        userSelected: () => void;
        canAddAssignment: boolean;
        removeClaim:any;
        addAssignmentToInclude:any;
        claimToAdd:Wars.Domain.Model.ClaimDefinition;
        getAssignments: () => Wars.Domain.Model.Dtos.ProcessAssignmentDto[];
    }

    export class ManageAssignments implements IDirective {
        public link($scope: IManageAssignmentsScope,
            element: JQuery,
            attrs: ng.IAttributes) {
        }

        public templateUrl = './app/views/directives/manageForm/manageAssignments.html';
        public controller = [
            '$scope', 'formService', 'growl', 'claimDefinitionService', 'reviewConfigurationService', 'userService', "conditionService",
            'processService', 'configurationCacheService', '$q','assignmentConfigurationService', ManageAssignmentsController];
        public controllerAs = 'controller';
        public restrict: string = 'E';
        public scope: any = {
            isConfigureMode: "=",
            isEditMode: "=",
            manageSection: "=",
            process: "=",
            processConfigurationId:"="
        };
    }

    export class ManageAssignmentsController {
        public selectedUser: any;

        private currentUser: models.User;
        private selectedUserId: string;
        private processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        private processClaimDefinitions: Wars.Domain.Model.ClaimDefinition[];
        private userClaims: Wars.Domain.Model.Dtos.UserClaimDto[];
        private assignmentSection: Wars.Domain.Model.Dtos.AssignmentSectionDto;

        constructor(
            private scope: IManageAssignmentsScope,
            private formService: services.FormService,
            private growl: angular.growl.IGrowlService,
            private claimDefinitionService: services.ClaimDefinitionService,
            private reviewConfigurationService: services.ReviewConfigurationService,
            private userService: services.UserService,
            private conditionService: services.ConditionService,
            private processService: services.ProcessService,
            private configurationCache: services.ConfigurationCacheService,
            private $q: angular.IQService,
            private assigmentConfigurationService: services.AssignmentConfigurationService)
        {
            scope.deleteAssignment = (a) => this.deleteAssignment(a);
            scope.searchUsers = (a) => this.searchUsers(a);
            scope.addAssignment = () => this.addAssignment();
            scope.saveAdd = () => this.saveAdd();
            scope.cancel = () => this.cancel();
            scope.save = () => this.save();
            scope.userSelected = () => this.userSelected();
            scope.addAssignmentToInclude = () => this.addAssignmentToInclude();
            scope.removeClaim = (c) => this.removeClaim(c);
            scope.getAssignments = () => this.getAssignments();
            scope.clearUser = () => this.clearUser();


            if (this.scope.isConfigureMode) {
                this.reviewConfigurationService.getExtensibleUserRepositories().then(
                    (userRepositories) => {
                        scope.userRepositories = userRepositories;
                    });

                this.claimDefinitionService.getAllProcessClaims(this.scope.processConfigurationId).then(claims => {
                    this.scope.processClaimDefinitions = claims;
                });
            }

            if (!this.scope.isConfigureMode) {
                configurationCache.getVersionedProcessConfiguration(this.scope.processConfigurationId).then(
                        (processConfiguration) => {
                            this.processConfiguration = processConfiguration;
                        }).then(() => {
                            this.setCanAssign();
                        });
            }

            this.currentUser = userService.getCurrentUser();
        }

        public removeClaim(claim: Wars.Domain.Model.AssignmentSectionClaim) {
            claim.entityAspect.setDeleted();
            this.save();
        }

        public clearUser() {
            this.scope.selectedUser = null;
            this.selectedUser = null;
            this.selectedUserId = null;
            this.save();
        }

        public getAssignments() {
            if (!this.scope.process)
                return [];

            return Enumerable.from(this.scope.process.processAssignments).where(p =>
                Enumerable.from(this.scope.manageSection.assignmentConfiguration.assignmentSectionClaims)
                .any(a => a.claimDefinition.uniqueIdentifier === p.claimUniqueId)).toArray();
        }

        public searchUsers(viewValue) {
            var searchCriteria = new models.UserSearchCriteria();
            searchCriteria.userRepository = this.scope.manageSection.assignmentConfiguration.userServiceName;
            searchCriteria.userName = viewValue;
            return this.userService.searchUsers(searchCriteria);;
        }

        public deleteAssignment(assignment: Wars.Domain.Model.Dtos.ProcessAssignmentDto) {
            if (!Enumerable.from(this.scope.processClaims).any(pc => pc.uniqueIdentifier === assignment.claimUniqueId)) {
                this.growl.error("You do not have authority to remove this assignment.");
                return;
            }

            var matches = Enumerable.from(this.assignmentSection.assignmentRights)
                .where(i => i.processClaimUniqueId == assignment.claimUniqueId)
                .toArray();

            var noRestrictionMatches = Enumerable.from(matches)
                .where(i => (!i.preventAssignmentRemovalOfSelf || assignment.assignedUserId !== this.currentUser.userId) && !i.unAssignConditionExists)
                .toArray();

            if (noRestrictionMatches.length > 0) {
                this.deleteAssignmentInternal(assignment);
                return;
            }

            if (assignment.assignedUserId === this.currentUser.userId && Enumerable.from(matches).all(i => i.preventAssignmentRemovalOfSelf)) {
                this.growl.error("You are not allowed to remove this assignment from yourself.");
                return;
            }

            var possibleAssignments = Enumerable.from(matches)
                .where(i => (!i.preventAssignmentRemovalOfSelf || assignment.assignedUserId !== this.currentUser.userId))
                .toArray();

            this.conditionService.executeUnAssigConditions(this.scope.process.id, assignment.id, possibleAssignments).then(
                (assignmentChecks: Wars.Domain.Model.Dtos.AssignmentCheckDto[]) => {
                    var anyConditionsPassed = Enumerable.from(assignmentChecks).any(i => i.wasSuccessful);
                    if (anyConditionsPassed) {
                        this.deleteAssignmentInternal(assignment);
                        return;
                    }

                    var failureMessage = this.getFailureMessage(assignmentChecks);

                    if (failureMessage === "") {
                        this.growl.error("You are not authorized to remove this assignment.");
                    } else {
                        this.growl.error("One of the following issue(s) is preventing you from removing this assignment: " + failureMessage);
                    }
                    return;
                });
        }

        private getFailureMessage(assignmentChecks: Wars.Domain.Model.Dtos.AssignmentCheckDto[]): string {
            var failureMessage = "";
            var firstCheck = true;
            for (var i = 0; i < assignmentChecks.length; i++) {
                if (assignmentChecks[i].failureMessage == null) continue;
                if (!firstCheck) {
                    failureMessage += ", ";
                }
                failureMessage += assignmentChecks[i].failureMessage;
                firstCheck = false;
            }
            return failureMessage;
        }

        private deleteAssignmentInternal(assignment: Wars.Domain.Model.Dtos.ProcessAssignmentDto): void {
            this.processService.deleteAssignment(this.scope.process.id, assignment.id)
                .then(r => {
                    this.scope.process.processAssignments.remove(assignment);
                });
        }

        public addAssignment() {
            this.scope.newAssignment = {};
            this.scope.isAdding = true;
        }

        public addAssignmentToInclude() {
            if (Enumerable.from(this.scope.manageSection.assignmentConfiguration.assignmentSectionClaims)
                .any(a => a.claimDefinition_id === this.scope.claimToAdd.id)) {
                this.growl.error("This claim is already added.");
                return;
            }
           
            let newSectionClaim = this.assigmentConfigurationService.createAssigmentSectionClaim();

            newSectionClaim.claimDefinition_id = this.scope.claimToAdd.id;
            newSectionClaim.assignmentConfiguration = this.scope.manageSection.assignmentConfiguration;

            this.scope.manageSection.assignmentConfiguration.assignmentSectionClaims.push(newSectionClaim);
            this.save();
        }

        public saveAdd() {
            if (this.selectedUserId === null || this.selectedUserId === undefined) {
                this.growl.error("A user must be selected to continue.");
                return;
            }

            if (this.scope.processClaims.length === 1) {
                this.scope.newAssignment.claimDefinition = this.scope.processClaims[0];
            }

            this.scope.newAssignment.assignedUserId = this.selectedUserId;
            this.scope.newAssignment.claimUniqueId = this.scope.newAssignment.claimDefinition.uniqueIdentifier;
            const claimUniqueId = this.scope.newAssignment.claimDefinition.uniqueIdentifier;

            var processClaim = Enumerable.from(this.scope.processClaims).single(c => c.id === this.scope.newAssignment.claimDefinition.id);

            if (processClaim.maxAssignments && processClaim.maxAssignments > 0) {
                if (processClaim.maxAssignments <= Enumerable.from(this.scope.process.processAssignments).count(x => x.claimUniqueId === claimUniqueId)) {
                    this.growl.error("This assignment has already been assigned to the maximum number of users.");
                    return;
                }
            }
            if (Enumerable.from(this.scope.process.processAssignments)
                .any(a => a.assignedUserId === this.scope.newAssignment.assignedUserId && a.claimUniqueId === this.scope.newAssignment.claimUniqueId)) {
                this.growl.error("This assignment has already been added to this user");
                return;
            }

            var matches = Enumerable.from(this.assignmentSection.assignmentRights)
                .where(i => i.processClaimUniqueId == this.scope.newAssignment.claimUniqueId)
                .toArray();

            var noRestrictionMatches = Enumerable.from(matches)
                .where(i => !i.assignConditionExists)
                .toArray();

            if (noRestrictionMatches.length > 0) {
                this.addAssignmentInternal();
                return;
            }

            this.conditionService.executeAssignConditions(
                this.scope.process.id,
                this.scope.newAssignment.claimUniqueId,
                this.scope.newAssignment.assignedUserId,
                matches).then(
                (assignmentChecks: Wars.Domain.Model.Dtos.AssignmentCheckDto[]) => {
                    var anyConditionsPassed = Enumerable.from(assignmentChecks).any(i => i.wasSuccessful);
                    if (anyConditionsPassed) {
                        this.addAssignmentInternal();
                        return;
                    }

                    var failureMessage = this.getFailureMessage(assignmentChecks);

                    if (failureMessage === "") {
                        this.growl.error("You are not authorized to add this assignment.");
                    } else {
                        this.growl.error("One of the following issue(s) is preventing you from adding this assignment: " + failureMessage);
                    }
                    return;
            });
        }

        private addAssignmentInternal() {
            delete this.scope.newAssignment.claimDefinition;

            this.processService.addAssignment(this.scope.process.id, this.scope.newAssignment).then(a => {
                this.scope.process.processAssignments.push(a);

                this.scope.newAssignment = null;
                this.scope.isAdding = false;
                this.scope.selectedUser = null;
                this.selectedUser = null;
                this.selectedUserId = null;
            });
        }

        private setCanAssign() {
            this.assignmentSection = this.scope.process.assignmentSections[this.scope.manageSection.uniqueIdentifier];
            var assignableClaimUniqueIds = Enumerable.from(this.assignmentSection.assignmentRights)
                .select(i => i.processClaimUniqueId)
                .toArray();

            this.scope.processClaims = Enumerable.from(this.processConfiguration.myClaims).where(i => assignableClaimUniqueIds.indexOf(i.uniqueIdentifier) !== -1).toArray();
            this.scope.canAddAssignment = this.scope.processClaims.length > 0;
        }

        private userSelected() {
            if (!this.scope.selectedUser)
                return;

            if (this.scope.selectedUser.isExternal) {
                this.userService.addExternalUser(this.scope.selectedUser)
                    .then(id => {
                        this.selectedUserId = id;
                    });
            } else {
                this.selectedUserId = this.scope.selectedUser.id;
            }
        }

        public cancel() {
            this.scope.newAssignment = null;
            this.scope.isAdding = false;
            this.scope.selectedUser = null;
            this.selectedUser = null;
            this.selectedUserId = null;
        }

        public save() {
            this.formService.saveAllChanges();
        }
    }
}
warsApp.registerDirective('ManageAssignments', []);